var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPromageLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 143,
    height: 35,
    viewBox: "0 0 143 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_6_1015)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.1963 16.5318C25.3225 15.5962 26.0386 14.1911 26.0386 12.6199C26.0386 11.0488 25.3225 9.64365 24.1963 8.70811C24.3254 8.64611 24.4496 8.57882 24.5679 8.5059C25.3149 8.04515 26.1966 7.77905 27.1409 7.77905C29.8361 7.77905 32.0209 9.94643 32.0209 12.6199C32.0209 15.2935 29.8361 17.4608 27.1409 17.4608C26.1966 17.4608 25.3149 17.1947 24.5679 16.734C24.4496 16.6611 24.3254 16.5938 24.1963 16.5318Z",
    fill: "#E65F2B"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_6_1015)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.8409 13.3833C23.3447 12.0145 23.2566 10.4424 22.4647 9.08177C21.6728 7.72114 20.3443 6.85943 18.8975 6.60782C18.978 6.49014 19.0516 6.37025 19.1173 6.2484C19.532 5.47889 20.1615 4.81112 20.9793 4.34272C23.3134 3.00595 26.298 3.79925 27.6455 6.11461C28.993 8.42997 28.1933 11.3906 25.8592 12.7274C25.0414 13.1958 24.1437 13.4026 23.2646 13.3742C23.1254 13.3696 22.9839 13.373 22.8409 13.3833Z",
    fill: "#E65F2B"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_6_1015)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0802 11.3273C19.8266 9.89205 18.9579 8.57419 17.5863 7.78863C16.2147 7.00307 14.6298 6.91575 13.25 7.41547C13.2605 7.27361 13.2638 7.13326 13.2592 6.99518C13.2305 6.12305 13.4391 5.23254 13.9112 4.42125C15.2588 2.10589 18.2433 1.31259 20.5774 2.64936C22.9114 3.98614 23.7112 6.94678 22.3636 9.26216C21.8914 10.0734 21.2183 10.6979 20.4425 11.1093C20.3197 11.1744 20.1989 11.2474 20.0802 11.3273Z",
    fill: "#E65F2B"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_6_1015)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.6506 10.917C15.7075 9.79982 14.291 9.0894 12.7071 9.0894C11.1233 9.0894 9.70678 9.79982 8.7637 10.917C8.70123 10.789 8.63338 10.6657 8.55985 10.5484C8.09539 9.80734 7.82715 8.93273 7.82715 7.99592C7.82715 5.32237 10.012 3.15503 12.7071 3.15503C15.4023 3.15503 17.5871 5.32237 17.5871 7.99592C17.5871 8.93273 17.3188 9.80734 16.8544 10.5484C16.7808 10.6657 16.713 10.789 16.6506 10.917Z",
    fill: "#E65F2B"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_6_1015)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.4772 12.2615C12.0974 11.7617 10.5125 11.8491 9.14091 12.6346C7.76929 13.4201 6.90062 14.738 6.64699 16.1732C6.52836 16.0933 6.40749 16.0203 6.28467 15.9552C5.50893 15.5438 4.83577 14.9194 4.3636 14.1081C3.01602 11.7927 3.81573 8.83211 6.14979 7.49532C8.48384 6.15853 11.4684 6.95184 12.816 9.26722C13.2882 10.0785 13.4967 10.969 13.4679 11.8411C13.4634 11.9792 13.4668 12.1195 13.4772 12.2615Z",
    fill: "#E65F2B"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_6_1015)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.4027 15.0012C9.9558 15.2528 8.62731 16.1145 7.83541 17.4751C7.0435 18.8357 6.95547 20.4079 7.45923 21.7767C7.31622 21.7663 7.17471 21.763 7.0355 21.7674C6.15634 21.796 5.25864 21.5891 4.4408 21.1207C2.10675 19.7839 1.30704 16.8233 2.65461 14.5079C4.00217 12.1926 6.98672 11.3992 9.32077 12.7361C10.1386 13.2045 10.7681 13.8722 11.1828 14.6417C11.2484 14.7635 11.3221 14.8834 11.4027 15.0012Z",
    fill: "#E65F2B"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_d_6_1015)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.9877 18.4018C9.86151 19.3373 9.14532 20.7425 9.14532 22.3135C9.14532 23.8847 9.86151 25.2899 10.9877 26.2254C10.8586 26.2873 10.7344 26.3547 10.6161 26.4276C9.86912 26.8883 8.98742 27.1544 8.04306 27.1544C5.34792 27.1544 3.16309 24.9871 3.16309 22.3135C3.16309 19.64 5.34792 17.4727 8.04306 17.4727C8.98742 17.4727 9.86912 17.7388 10.6161 18.1995C10.7344 18.2725 10.8586 18.3397 10.9877 18.4018Z",
    fill: "#E65F2B"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_d_6_1015)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.3421 21.5515C11.8382 22.9203 11.9263 24.4924 12.7182 25.8531C13.5101 27.2138 14.8386 28.0754 16.2854 28.327C16.2049 28.4447 16.1313 28.5646 16.0656 28.6865C15.6509 29.456 15.0214 30.1237 14.2036 30.5921C11.8695 31.9289 8.88499 31.1356 7.53742 28.8203C6.18985 26.5049 6.98956 23.5443 9.32361 22.2074C10.1415 21.7391 11.0392 21.5322 11.9183 21.5607C12.0575 21.5652 12.199 21.5619 12.3421 21.5515Z",
    fill: "#E65F2B"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_d_6_1015)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.1059 23.6082C15.3596 25.0434 16.2282 26.3613 17.5999 27.1467C18.9715 27.9323 20.5564 28.0197 21.9362 27.5199C21.9257 27.6618 21.9224 27.8021 21.9269 27.9403C21.9557 28.8124 21.7472 29.7029 21.275 30.5142C19.9274 32.8296 16.9429 33.6229 14.6088 32.286C12.2747 30.9493 11.475 27.9887 12.8226 25.6733C13.2948 24.862 13.9679 24.2376 14.7436 23.8262C14.8665 23.7611 14.9873 23.688 15.1059 23.6082Z",
    fill: "#E65F2B"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_d_6_1015)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.5342 24.0208C19.4773 25.1379 20.8938 25.8483 22.4776 25.8483C24.0615 25.8483 25.478 25.1379 26.4211 24.0208C26.4835 24.1488 26.5513 24.272 26.6249 24.3893C27.0894 25.1303 27.3576 26.005 27.3576 26.9418C27.3576 29.6154 25.1728 31.7827 22.4776 31.7827C19.7825 31.7827 17.5977 29.6154 17.5977 26.9418C17.5977 26.005 17.8659 25.1303 18.3303 24.3893C18.4039 24.272 18.4717 24.1488 18.5342 24.0208Z",
    fill: "#E65F2B"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_d_6_1015)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.709 22.6759C23.0888 23.1757 24.6736 23.0883 26.0453 22.3028C27.4169 21.5173 28.2855 20.1994 28.5392 18.7642C28.6578 18.844 28.7786 18.9171 28.9015 18.9822C29.6773 19.3936 30.3504 20.018 30.8226 20.8293C32.1702 23.1447 31.3704 26.1053 29.0364 27.4421C26.7023 28.7789 23.7178 27.9856 22.3702 25.6702C21.898 24.8589 21.6895 23.9684 21.7182 23.0963C21.7228 22.9582 21.7194 22.8179 21.709 22.6759Z",
    fill: "#E65F2B"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter11_d_6_1015)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.3514 17.4567C27.3504 17.4584 27.3494 17.4601 27.3484 17.4618C26.5566 18.8224 25.2281 19.6841 23.7812 19.9357C23.8617 20.0535 23.9354 20.1734 24.0011 20.2951C24.4158 21.0647 25.0453 21.7324 25.8631 22.2008C28.1972 23.5377 31.1817 22.7443 32.5293 20.429C33.6845 18.4439 33.2616 15.9847 31.6466 14.481C30.9371 16.17 29.2908 17.3747 27.3514 17.4567Z",
    fill: "#E65F2B"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.1836 25.4656V8.46777H49.9981C53.6324 8.46777 56.0474 10.6775 56.0474 14.1256C56.0474 17.5495 53.6324 19.7592 49.9981 19.7592H46.7702V25.4656H43.1836ZM49.6633 11.5031H46.7702V16.7238H49.6633C51.337 16.7238 52.413 15.7283 52.413 14.1256C52.413 12.4987 51.337 11.5031 49.6633 11.5031Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64.7046 12.9843H65.2785V16.0925H63.9395C61.931 16.0925 61.1659 17.4523 61.1659 19.3464V25.4656H57.7945V12.9843H60.855L61.1659 14.8541C61.8354 13.7371 62.7918 12.9843 64.7046 12.9843Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M72.3888 25.6113C68.4675 25.6113 65.9091 23.0616 65.9091 19.2249C65.9091 15.3883 68.4675 12.8386 72.3888 12.8386C76.3101 12.8386 78.8685 15.3883 78.8685 19.2249C78.8685 23.0859 76.3101 25.6113 72.3888 25.6113ZM72.3888 22.8188C74.2777 22.8188 75.4493 21.3375 75.4493 19.2249C75.4493 17.1124 74.2777 15.6311 72.3888 15.6311C70.4999 15.6311 69.3522 17.1124 69.3522 19.2249C69.3522 21.3375 70.4999 22.8188 72.3888 22.8188Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M95.4291 12.8386C97.9636 12.8386 99.9721 14.2956 99.9721 18.3022V25.4656H96.6007V18.4965C96.6007 16.6267 95.9312 15.6554 94.4727 15.6554C93.0141 15.6554 92.0338 16.7481 92.0338 18.6422V25.4656H88.6624V18.4965C88.6624 16.6267 87.993 15.6554 86.5105 15.6554C85.052 15.6554 84.0956 16.7967 84.0956 18.6664V25.4656H80.7242V12.9843H83.6652L83.976 14.5384C84.7172 13.5671 85.7932 12.8629 87.5865 12.8386C89.0928 12.8144 90.5036 13.3729 91.2687 14.9512C92.1295 13.6157 93.5641 12.8386 95.4291 12.8386Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M113.806 22.5759H114.188V25.4656H112.467C110.721 25.4656 110.171 24.6157 110.195 23.4258C109.334 24.8099 108.091 25.6113 106.178 25.6113C103.524 25.6113 101.611 24.3243 101.611 21.9446C101.611 19.2978 103.572 17.7923 107.254 17.7923H109.693V17.1852C109.693 16.0682 108.904 15.3397 107.493 15.3397C106.178 15.3397 105.293 15.9468 105.15 16.8695H101.898C102.137 14.4413 104.337 12.8386 107.589 12.8386C111.032 12.8386 113.016 14.3927 113.016 17.3795V21.7989C113.016 22.4545 113.279 22.5759 113.806 22.5759ZM109.693 20.3177V20.0748H107.23C105.819 20.0748 105.007 20.6576 105.007 21.7018C105.007 22.5759 105.7 23.1344 106.824 23.1344C108.593 23.1344 109.669 22.0174 109.693 20.3177Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M124.53 14.7084L124.817 12.9843H127.782V25.1013C127.782 28.1852 125.917 30.4678 121.207 30.4678C117.788 30.4678 115.444 28.8894 115.277 25.9998H118.672C118.983 27.1896 119.916 27.8695 121.47 27.8695C123.359 27.8695 124.483 26.9225 124.483 24.9799V23.6687C123.67 24.7128 122.45 25.3927 120.729 25.3927C117.429 25.417 115.014 22.9645 115.014 19.1035C115.014 15.2912 117.429 12.8144 120.705 12.8144C122.474 12.8144 123.717 13.6157 124.53 14.7084ZM121.47 22.6488C123.311 22.6488 124.459 21.2161 124.459 19.1521C124.459 17.0638 123.311 15.5826 121.47 15.5826C119.629 15.5826 118.457 17.0395 118.457 19.1278C118.457 21.2161 119.629 22.6488 121.47 22.6488Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M136.206 25.6113C132.117 25.6113 129.655 23.1102 129.655 19.2492C129.655 15.364 132.165 12.8386 135.967 12.8386C139.649 12.8386 142.136 15.1698 142.184 18.8364C142.184 19.2007 142.16 19.6135 142.088 20.002H133.169V20.172C133.241 21.9446 134.365 23.013 136.063 23.013C137.425 23.013 138.382 22.406 138.669 21.2404H141.992C141.61 23.6687 139.482 25.6113 136.206 25.6113ZM133.241 17.768H138.788C138.549 16.2382 137.521 15.3883 135.991 15.3883C134.532 15.3883 133.432 16.2868 133.241 17.768Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_6_1015",
    x: 22.1963,
    y: 5.77905,
    width: 11.8242,
    height: 13.6816,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6_1015"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6_1015",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_6_1015",
    x: 16.8975,
    y: 1.69336,
    width: 13.4023,
    height: 13.6899,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6_1015"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6_1015",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_6_1015",
    x: 11.25,
    y: 0,
    width: 13.7686,
    height: 13.3274,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6_1015"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6_1015",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_6_1015",
    x: 5.82715,
    y: 1.15503,
    width: 13.7598,
    height: 11.762,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6_1015"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6_1015",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_6_1015",
    x: 1.70898,
    y: 4.84595,
    width: 13.7686,
    height: 13.3274,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6_1015"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6_1015",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_6_1015",
    x: 0,
    y: 10.0867,
    width: 13.4023,
    height: 13.6899,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6_1015"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6_1015",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_d_6_1015",
    x: 1.16309,
    y: 15.4727,
    width: 11.8242,
    height: 13.6819,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6_1015"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6_1015",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_d_6_1015",
    x: 4.88281,
    y: 19.5515,
    width: 13.4023,
    height: 13.6899,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6_1015"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6_1015",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_d_6_1015",
    x: 10.168,
    y: 21.6082,
    width: 13.7686,
    height: 13.3274,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6_1015"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6_1015",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_d_6_1015",
    x: 15.5977,
    y: 22.0208,
    width: 13.7598,
    height: 11.762,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6_1015"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6_1015",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_d_6_1015",
    x: 19.709,
    y: 16.7642,
    width: 13.7686,
    height: 13.3274,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6_1015"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6_1015",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_d_6_1015",
    x: 21.7812,
    y: 12.481,
    width: 13.4023,
    height: 12.3694,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6_1015"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6_1015",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromageLogo);
export default __webpack_public_path__ + "static/media/promage-logo.f7265256b82364fe460b3878961129b4.svg";
export { ForwardRef as ReactComponent };